import { useState, useEffect } from "react";
import { TextWrapper, Wrapper, TextWrapperSpan, FlexColumn } from "../../../constants/common/StyledGlobalConstants";
import { useDispatch, useSelector } from "react-redux";
import { StarSpan } from "../VehicleorAssetDetails/CamerasAndOtherAccessories";
import { setRescheduleAppointmentDetails } from "../../../store/actions/schedulingportal/technicianAppointment";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";
import Select from "react-select";
import PropTypes from "prop-types";
const { TABLET } = DEVICE_BREAKPOINTS;

const RescheduleReason = ({ setIsNextDisabled }) => {
  const { windowSize } = useSelector((state) => state.ACCOUNT);
  const isMobile = windowSize.width < TABLET;
  const { isReschedule, rescheduleAppointmentDetails, rescheduleReasons } = useSelector((state) => state.TECHNICIANAPPOINTMENT);
  const [rescheduleReason, setRescheduleReason] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    isReschedule &&
      !rescheduleAppointmentDetails?.isDefaultReasonSelected &&
      rescheduleAppointmentDetails.reasonName &&
      setRescheduleReason(rescheduleAppointmentDetails.reasonName);
  }, []);

  useEffect(() => {
    rescheduleReason ? setIsNextDisabled(false) : setIsNextDisabled(true); //disable Next if appointment date and time is not selected
    let reason = rescheduleReasons?.reasons?.find((item) => item.mappedName === rescheduleReason);
    let appointmentDetails = {
      ...rescheduleAppointmentDetails,
      reason: reason?.description || "",
      reasonName: rescheduleReason,
      rescheduleReasonCode: reason?.code || "",
      isDefaultReasonSelected: false,
    };
    dispatch(setRescheduleAppointmentDetails(appointmentDetails));
  }, [rescheduleReason]);

  function getRescheduleOptionBackgroundColor(state) {
    if (state.isFocused) {
      return "#0000000D";
    }
    if (state.isSelected) {
      return "var(--background-secondary, #F6F6F6)";
    }
    return "transparent";
  };

  return (
    <Wrapper marginBottom="6rem">
      {/* <FormTitle title="Why do you want to reschedule your service?" subTitle="Select the main reason for rescheduling your appointment." /> */}
      <TextWrapper fontSize={isMobile ? "1.25rem" : "1.5rem"} fontWeight="700" lineHeight={isMobile ? "1.5rem" : "2rem"} tabIndex={0}>
        Why do you want to reschedule your service?
      </TextWrapper>
      <TextWrapper marginTop="1.5rem !important" fontSize="0.875rem">
        Select the main reason for rescheduling your appointment.
      </TextWrapper>
      <FlexColumn flex={1}>
        <TextWrapperSpan fontSize="0.75rem" fontWeight="700" lineHeight="0.75rem" marginTop="2rem !important" marginBottom="4px !important">
          Reason <StarSpan disabled={!rescheduleReasons?.reasons.length}>*</StarSpan>
        </TextWrapperSpan>
        <Select
          className="slots-dropdown-react"
          styles={{
            container: (base) => ({
              ...base,
              width: !isMobile ? "60%" : "100%",
            }),
            control: (base, state) => ({
              ...base,
              width: "100%",
              height: "2.75rem",
              border: state.isFocused ? "2px solid var(--feedback-information, #006FC1)" : "1px solid #d8dada",
              borderRadius: "4px",
              fontSize: "0.875rem",
              fontFamily: '"neue-haas-grotesk-text"',
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              backgroundColor: state.isFocused ? "var(--background-secondary, #F6F6F6)" : "#fff",
              flexWrap: "nowrap",
              boxShadow: "none",
            }),

            placeholder: (base) => ({
              ...base,
              fontSize: "0.875rem",
              fontFamily: '"neue-haas-grotesk-text"',
              color: "#000",
            }),
            singleValue: (base) => ({
              ...base,
              color: "#000",
              fontSize: "0.875rem",
              fontFamily: '"neue-haas-grotesk-text"',
            }),
            indicatorSeparator: () => ({
              display: "none",
            }),
            menu: (base) => ({
              ...base,
              zIndex: 9999,
              backgroundColor: "#fff",
              border: "1px solid #d8dada",
              fontSize: "0.875rem",
              fontFamily: '"neue-haas-grotesk-text"',
              borderRadius: "4px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }),
            option: (base, state) => ({
              ...base,
              paddingTop: "14px", // Top padding
              paddingRight: "16px", // Right padding
              paddingBottom: "14px", // Bottom padding
              paddingLeft: "16px", // Left padding
              gap: "10px", // Gap between options
              fontSize: "0.875rem",
              fontWeight: 400,
              fontFamily: '"neue-haas-grotesk-text"',
              color: "#000",
              backgroundColor: getRescheduleOptionBackgroundColor(state),
              cursor: "pointer",
              padding: "0.5rem",
              borderLeft: state.isSelected ? "4px solid #EE0000" : "4px solid transparent",
              "&:active": {
                backgroundColor: "#0000001F",
              },
            }),
          }}
          value={rescheduleReasons?.reasons
            ?.map((item) => ({ label: item.mappedName, value: item.mappedName }))
            .find((option) => option.value === rescheduleReason)} // Ensure the selected value matches
          onChange={(selectedOption) => setRescheduleReason(selectedOption?.value || null)} // Update state with selected value
          options={rescheduleReasons?.reasons?.map((item) => ({
            label: item.mappedName,
            value: item.mappedName,
          }))}
          placeholder="Select reason"
          isDisabled={!rescheduleReasons?.reasons.length}
        />
      </FlexColumn>
    </Wrapper>
  );
};

RescheduleReason.propTypes = {
  setIsNextDisabled: PropTypes.func.isRequired,
};

export default RescheduleReason;
